// extracted by mini-css-extract-plugin
export default {"multiplayerBackground":"MultiplayerBackground_multiplayerBackground__tJToZ"};